const DataUtils = {
    isNoData(value) {
        let n = Number(value)
        return Number.isNaN(value) || n <= -9999
    },
    containsNoData(arr) {
        if (!Array.isArray(arr))
            throw new Error('Parameter must be an array')
        
        return arr.some((value) => this.isNoData(value))
    },
    toNumberArray(arr) {
        if (!Array.isArray(arr))
            throw new Error('Parameter must be an array')

        return arr.map((value) => new Number(value))
    },    
}

export default DataUtils